/** Created by razial on 16.02.2026. */

const EditorPointers = function (editorClient) { 
    cleverapps.EventEmitter.call(this);

    this.editorClient = editorClient;
    this.pointers = {};

    editorClient.on("message", this.handleMessage.bind(this), this);
    editorClient.on("updateEditors", this.onUpdateEditors.bind(this), this);
};

EditorPointers.prototype = Object.create(cleverapps.EventEmitter.prototype);
EditorPointers.prototype.constructor = EditorPointers;

EditorPointers.prototype.destructor = function () {
    this.stopTracking();
};

EditorPointers.prototype.startTracking = function () {
    if (this.pointerListener) {
        return;
    }

    this.pointerListener = cleverapps.inputDispatcher.on("mousemove", (touch) => {
        const now = Date.now();
        if (this._lastPointerSend && now - this._lastPointerSend < 100) {
            return;
        }
        this._lastPointerSend = now;

        const mapView = Map2d.currentMap.getMapView();
        const pos = mapView.convertTouchToNodeSpace(touch);
        pos.x = Math.floor(pos.x);
        pos.y = Math.floor(pos.y);

        this.editorClient.send("pointer", { x: pos.x, y: pos.y });
    });
};

EditorPointers.prototype.stopTracking = function () {
    if (this.pointerListener) {
        this.pointerListener.clear();
        this.pointerListener = undefined;
    }
};

EditorPointers.prototype.handleMessage = function (message) {
    const type = message.type;
    const data = message.data;

    if (type === "pointer") {
        const userId = data.userId;

        let pointer = this.pointers[userId];
        if (!pointer) {
            pointer = new EditorPointer(userId);
            this.pointers[userId] = pointer;
            this.trigger("addPointer", pointer);
        }

        pointer.setPosition(data.x, data.y);
    }
};

EditorPointers.prototype.onUpdateEditors = function () {
    const editors = this.editorClient.getEditors() || [];

    const removed = [];
    for (const userId in this.pointers) {
        if (editors.indexOf(userId) === -1) {
            removed.push(this.pointers[userId]);
            delete this.pointers[userId];
        }
    }

    removed.forEach(function (pointer) {
        this.trigger("removePointer", pointer);
    }, this);
};
